import { TagsList } from "@components/Listings/ListingsFilter/components/ListingsFilterCheckboxList"
import React, { useMemo } from "react"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { useFilterData } from "@components/Listings/ListingsFilter/FilterDataContextProvider"

export function TagsResort() {
    const selectedItems = useFilterStore((s) => s.resort?.short_name_in || [])
    const onListChangeResort = useFilterStore((s) => s.onListChangeResort)
    const filterData = useFilterData()
    const resortNames = useMemo(() => {
        return [
            ...filterData.disneyResorts.map((i) => ({
                key: i.short_name,
                group: "Walt Disney World Locations"
            })),
            ...filterData.nonDisneyResorts.map((i) => ({
                key: i.short_name,
                group: "Other Club Resort Locations"
            }))
        ]
    }, [filterData])

    return <TagsList selectedItems={selectedItems} width={280} withGroups items={resortNames} onItemChange={onListChangeResort} title="Resort" />
}
